import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import {AddBookmark, Bookmark} from "core/slices/models";
import {useState} from "react";
import {ButtonGroup} from "react-bootstrap";


interface BookmarkManagerProps {
  bookmark?: AddBookmark | Bookmark;
  show: boolean;
  handleClose?: () => void;
  onCreateBookmark?: (bookmark: AddBookmark | Bookmark) => void;
  onUpdateBookmark?: (bookmark: Bookmark) => void;
  onDeleteBookmark?: (bookmark: Bookmark) => void;
}

const BookmarkManager: React.FC<BookmarkManagerProps> = ({
                                                           bookmark,
                                                           show,
                                                           onCreateBookmark,
                                                           onUpdateBookmark,
                                                           onDeleteBookmark,
                                                           handleClose
                                                         }) => {


  const [draftName, setDraftName] = useState(bookmark?.name || "");
  const [isUpdateMode, setIsUpdateMode] = useState(!!(bookmark && bookmark.name));


  const handleUpdateClick = () => {
    const editBookmark = {
      ...bookmark,
      name: draftName,
    }
    onUpdateBookmark && onUpdateBookmark(editBookmark as Bookmark);
  }


  const handleCreateClick = () => {
    const createBookmark = {
      name: draftName,
    }
    onCreateBookmark && onCreateBookmark(createBookmark as AddBookmark);
  }

  const handleDeleteClick = () => {
    const deleteBookmark = {
      ...bookmark,
    }
    onDeleteBookmark && onDeleteBookmark(deleteBookmark as Bookmark);
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Bookmark</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name of bookmark"
                value={draftName}
                onChange={(e) => setDraftName(e.target.value)}
                autoFocus
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {isUpdateMode && (
            <ButtonGroup>
              <Button variant="primary" onClick={handleUpdateClick} disabled={!draftName.trim()}>
                Update
              </Button>
              <Button variant="danger" onClick={handleDeleteClick}>
                Delete
              </Button>
            </ButtonGroup>
          )}
          {!isUpdateMode && (
            <Button variant="primary" onClick={handleCreateClick} disabled={!draftName.trim()}>
              Create
            </Button>
          )}

        </Modal.Footer>
      </Modal>
    </>
  )
    ;
}

export default BookmarkManager;
